import { useState } from 'react';
import {
  BodyCard,
  CardContent,
  CardDescription,
  CardTitle,
  CardWrapper,
  GradientBg,
  IconWrapper,
  ListWrapper,
  Wrapper,
} from './style';
import {
  ContentWrapper,
  HomeDescription,
  HomeTitle,
  KeyText,
} from '../../style';
import HigherEfficiency from '@/assets/images/home/ic_high_effect.svg';
import LimitlessCreative from '@/assets/images/home/ic_limit_creative.svg';
import FasterProductivity from '@/assets/images/home/ic_faster_product.svg';
import ProfessionalResults from '@/assets/images/home/ic_professional_result.svg';
const benefits = [
  {
    key: 'higher-efficiency',
    title: 'Higher Efficiency',
    description: 'Save time & effort with AI-powered editing.',
    icon: HigherEfficiency,
  },
  {
    key: 'limitless-reative',
    title: 'Limitless Creative',
    description: 'Unleash creativity with inspiring content ideas.',
    icon: LimitlessCreative,
  },
  {
    key: 'faster-productivity',
    title: 'Faster Productivity',
    description: 'Boost efficiency for engaging content creation.',
    icon: FasterProductivity,
  },
  {
    key: 'professional-results',
    title: 'Professional Results',
    description:
      'Achieve professional quality without extensive editing skills.',
    icon: ProfessionalResults,
  },
];

export default function Benefit() {
  return (
    <Wrapper>
      <ContentWrapper>
        <KeyText>BENEFITS</KeyText>
        <HomeTitle>Achieve more with less effort</HomeTitle>
        <HomeDescription>
          Simplify complex tasks, streamline workflows, and amplify your
          creativity without breaking a sweat.
        </HomeDescription>
      </ContentWrapper>
      <ListWrapper>
        {benefits.map((benefit) => (
          <BenefitCard key={benefit.key} benefit={benefit} />
        ))}
      </ListWrapper>
    </Wrapper>
  );
}

export const BenefitCard = ({ benefit }: any) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <CardWrapper
      onMouseEnter={() => {
        setIsHovered(true);
      }}
      onMouseLeave={() => {
        setIsHovered(false);
      }}
    >
      <GradientBg style={{ opacity: isHovered ? 1 : 0 }} />
      <BodyCard>
        <IconWrapper>
          <img
            src={benefit.icon}
            alt={benefit.key}
            style={{ transform: isHovered ? 'scale(1.2)' : 'scale(1)' }}
          />
        </IconWrapper>
        <CardContent
        >
          <CardTitle>{benefit.title}</CardTitle>
          <CardDescription>{benefit.description}</CardDescription>
        </CardContent>
      </BodyCard>
    </CardWrapper>
  );
};
